import React from 'react';

import Card from '../../components/Card/Card';
import GqlQueryWrapper from '../../components/GqlQueryWrapper/GqlQueryWrapper';
import Table from '../../components/Table/Table';
import TablePreRender from '../../components/Table/Table.prerender';
import TitleWithDescription from '../../components/TitleWithDescription/TitleWithDescription';

import styles from './LipperRankingsTable.css';
import { LIPPER_RANKING_TABLE } from './queries';
import { lipperRankingUtil } from './util';

const LipperRankingsTable = ({ ticker }) => (
    <Card>
        <GqlQueryWrapper
            query={LIPPER_RANKING_TABLE}
            variables={{ ticker }}
            dataFunc={lipperRankingUtil}
            placeholder={() => <TablePreRender />}
        >
            {({ data: { asOfDate, data } }) => (
                <React.Fragment>
                    <div className="cat-container">
                        <div className="category-label">Lipper Category</div>
                        <div className="category">
                            {data.categoryName || '-'}
                        </div>
                    </div>
                    <TitleWithDescription
                        title="Lipper Rankings"
                        rightText={() => `As of ${asOfDate}`}
                    />
                    <Table data={{ data }} />
                </React.Fragment>
            )}
        </GqlQueryWrapper>
        <div className="lipper-footer-text">Based on cumulative rankings</div>
        <style jsx>{styles}</style>
    </Card>
);

export default LipperRankingsTable;
